import { render, staticRenderFns } from "./list - 副本.vue?vue&type=template&id=4bb53b77"
import script from "./list - 副本.vue?vue&type=script&lang=js"
export * from "./list - 副本.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports